export default __webpack_public_path__ + "static/media/icon-close-dark.295bb05e.svg";